import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * `<fader>` — linear slider primitive.
 *
 * Long-throw motion, optional centre-detent (used for paint controls where
 * unity gain sits in the middle of the throw). Continuous value emission
 * via pointer events; keyboard arrow keys provide a fine-step accessibility
 * fallback that emits the same CustomEvent payload.
 */
@customElement('panel-fader')
export class FaderElement extends LitElement {
  static override styles = [
    css`
      :host {
        display: inline-block;
        contain: layout paint;
        block-size: 100%;
        inline-size: 100%;
      }
    `,
  ];

  /** Whether the fader has a tactile centre detent. */
  @property({ type: Boolean, reflect: true }) accessor centreDetent = false;

  /** Throw orientation. Defaults to vertical, mirroring physical hardware. */
  @property({ type: String, reflect: true }) accessor orientation: 'vertical' | 'horizontal' =
    'vertical';

  override render() {
    // TODO(Phase 2): SVG rail and thumb geometry, pointer-driven thumb
    // tracking, optional centre-detent quantisation around the midpoint.
    return html`<svg viewBox="0 0 40 200" aria-label="fader"></svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'panel-fader': FaderElement;
  }
}
